export class claimRewards {
    campaign_id: number;
    customer_id: any;
    


constructor(values: Object = {}) {
    Object.assign(this, values);
}
}


// WEBPACK FOOTER //
// ./src/app/claimReward/claim.ts